import { itemsPerPage } from 'core/constants/pagination.constants';
import { DEFAULT_PAGE } from 'core/constants/platform.constants';
import type { IShortcutsState } from './shortcuts.types';

export const SLICE_NAMESPACE = 'shortcuts';

export const initialState: IShortcutsState = {
  filters: {
    query: '',
    segmentFiltersSelected: {
      priceGroupIds: [],
      priceListIds: [],
    },
  },
  shortcutList: {
    isLoading: false,
    isSuccess: false,
    error: null,
    data: [],
  },
  shortcutListPagination: {
    totalItems: 0,
    totalPages: 0,
    currentPage: DEFAULT_PAGE,
    itemsPerPage,
  },
  formPriceGroups: {
    isLoading: false,
    isSuccess: false,
    error: null,
    data: [],
  },
  form: {
    isLoading: false,
    isSuccess: false,
  },
  deleteConfirmation: {
    isLoading: false,
    isSuccess: false,
    error: null,
  },
};
